<template>
  <div>
    <headerimg></headerimg>
    <div class="success-conter">
      <div>
        <img style="width: 4.74rem; margin-top: 0.78rem;" src="../../assets/images/mpesa/success@2x.png" alt="">
      </div>
      <p class="test-1">Payment Successful</p>
      <div>
        <p class="test-2">Your payment of KES {{parseInt(Params.amount || '0').toLocaleString()}} to Safaricom Airtime was successfully completed.</p>
      </div>
      <div>
        <p class="test-3">Transaction Reference:{{sessionId}}</p>
      </div>
    </div>
    <div class="btn" v-if="url && !urlstatus">
      <button @click="gotourl">Okay</button>
    </div>

    <emailtext></emailtext>
  </div>
</template>

<script>
  import {encryption} from "../../utils/requestUtils";

  export default{
    data() {
      return{
        url:'',
        urlstatus:false,
        Params:'',
        sessionId:''
      }
    },
    mounted() {
      this.getParams()
      this.getUserInfo()
    },
    methods:{
      getParams() {

        this.Params = this.$route.query

      },
      gotourl(){
        window.location.href=this.url
      },
      getUserInfo() {
        this.axios.post('/api/order/paymentStatus', {
          requestParam: encryption({
            merchantId: this.Params.merchantId,
            merchantOrderId: this.Params.merchantOrderId
          })
        }).then(res => {
            this.url = res.data.data.callbackUrl
            this.sessionId = res.data.data.sessionId
            if(this.url.replace(0,5)!=='http'){
              this.urlstatus = true
            }
        })
      },
    }
  }
</script>

<style lang="scss">
  .success-conter{
    width: 6.54rem;

    margin: 0 auto;
    background: #FFFFFF;
    border-radius: 0.32rem;
    margin-top: 0.54rem;
    padding-bottom: 0.7rem;
    .test-1{
      font-size: 0.4rem;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      color: #39B549;
      margin-top: 0.48rem;
    }
    .test-2{
      width: 4.82rem;
      margin: 0 auto;
      font-size: 0.28rem;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: #151515;
      margin-top: 0.32rem;
    }
    .test-3{
      width: 3.1rem;
      margin: 0 auto;
      margin-top: 0.5rem;
      font-size: 0.28rem;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: #151515;
    }

  }
  .btn{
    button{
      border: none;
      width: 6.54rem;
      height: 1.08rem;
      background: linear-gradient(138deg, #8AFFA7 0%, #FEFD42 100%);
      border-radius: 0.16rem;
      font-size: 0.3rem;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      color: #151515;
      margin-top: 0.32rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/mpesa/success.vue